export default __webpack_public_path__ + "static/media/owner.69d924ee.jpeg";